import { createFileRoute, redirect } from "@tanstack/react-router";
import { Overview } from "@/features/subscriptions";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/subscription/overview/")({
  beforeLoad: ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["SUBSCRIPTION_VIEW", "SUBSCRIPTION_EDIT"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <Overview />,
});

export { Route };
